import React from 'react';
import { VehicleInfo } from '../../../../../models/osb-model/osb-vehicle-lookup';
import './confirm-vehicle-information.scss';

interface ConfirmVehicleInformationContent {
    modelNameHeading?: string;
    regNumberHeading?: string;
    vinNumberHeading?: string;
}

interface ConfirmVehicleInformationProps {
    vehicleInfo?: VehicleInfo;
    confirmModalContent?: ConfirmVehicleInformationContent;
}

const ConfirmVehicleInformation: React.FC<ConfirmVehicleInformationProps> = ({
    vehicleInfo,
    confirmModalContent,
}) => {
    // If registrationNumber is an empty string we still want to fall back to VIN.
    const displayedIdentifier = (() => {
        if (!vehicleInfo) return '-';
        const reg = vehicleInfo.registrationNumber?.trim();
        if (reg) return vehicleInfo.registrationNumber; // non-empty after trim
        const vin = vehicleInfo.vin?.trim();
        return vin || '-';
    })();

    // Extract year from buildDate (format assumed YYYY-MM or starting with YYYY)
    const extractYear = (buildDate?: string): string | undefined => {
        if (!buildDate) return undefined;
        const match = /^(\d{4})/.exec(buildDate.trim());
        return match ? match[1] : undefined;
    };

    const displayModelName = (() => {
        const name = vehicleInfo?.modelName?.trim();
        if (!name) return '-';
        const year = extractYear(vehicleInfo?.buildDate);
        return year ? `${year} ${name}` : name;
    })();

    return (
        <div className="confirm-vehicle-information">
            <div className="VehicleInfoCard">
                <ul>
                    <li>
                        {vehicleInfo?.vehicleImageURL ? (
                            <img
                                src={vehicleInfo.vehicleImageURL}
                                alt="Vehicle"
                                style={{
                                    maxWidth: '300px',
                                    maxHeight: '200px',
                                }}
                            />
                        ) : (
                            'No image'
                        )}
                    </li>
                    <li>
                        <ul className="vehicleDetails">
                            <li className="vehicleNameListItem">
                                <div className="vehicleNameWrapper">
                                    {confirmModalContent?.modelNameHeading ??
                                        ''}
                                </div>
                                <div className="vehicleNameWrapper">
                                    {displayModelName}
                                </div>
                            </li>
                            <li className="vehicleNameListItem">
                                <div className="vehicleNameWrapper">
                                    {vehicleInfo?.registrationNumber &&
                                    vehicleInfo.registrationNumber.trim() !== ''
                                        ? confirmModalContent?.regNumberHeading ??
                                          ''
                                        : confirmModalContent?.vinNumberHeading ??
                                          ''}
                                </div>
                                <div className="vehicleNameWrapper">
                                    {displayedIdentifier}
                                </div>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
    );
};

export default ConfirmVehicleInformation;
